$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox({
            alwaysShowClose: true
        });
    });
    $('.fadeIn').fadeIn(500);
    $('#main-container, .termsBox').overlayScrollbars({
        scrollbars : {
            dragScrolling: true,
            clickScrolling: true,
            touchSupport: true,
            snapHandle: true
        }
    });

    // ----floatin input label in input and select
    $('.form-group').find('.floating-control').each(function (index, ele) {
        let $ele = $(ele);
        if($ele.val() != '' || $ele.is(':selected') === true){
            $ele.parents('.floating-group').addClass('focused');
        }
    });
    $('.floating-control').on('focus', function (e) {
        $(this).parents('.floating-group').addClass('focused');
    }).on('blur', function(){
        if($(this).val().length > 0){
            $(this).parents('.floating-group').addClass('focused');
        }else{
            $(this).parents('.floating-group').removeClass('focused');
        }
    });
    $('.floating-control').on('change', function (e) {
        if($(this).is('select')){
            if($(this).val() === $("option:first", $(this)).val()) {
                $(this).parents('.floating-group').removeClass('focused');
            }else{
                $(this).parents('.floating-group').addClass('focused');
            }
        }
    });
    //---- select2 single----
    $('.customSelect').each(function() {
        let dropdownParents = $(this).parents('.select2Part');
        $(this).select2({
            dropdownParent: dropdownParents,
            minimumResultsForSearch: -1
        }).on("select2:open", function (e) {
            $('.select2-results').overlayScrollbars({ });
            $(this).parents('.floating-group').addClass('focused');
        }).on("select2:close", function (e) {
            if($(this).find(':selected').val() === ''){
                $(this).parents('.floating-group').removeClass('focused');
            }
        });
    });
    //---- select2 multiple----
    $('.customSelectMultiple').each(function() {
        let dropdownParents = $(this).parents('.select2Part');
        $(this).select2({
            dropdownParent: dropdownParents,
            closeOnSelect: false
        }).on("select2:open", function (e) {
            $('.select2-results').overlayScrollbars({ });
            $(this).parents('.floating-group').addClass('focused');
        }).on("select2:close", function (e) {
            if($(this).val() != ''){
                $(this).parents('.floating-group').addClass('focused');
            }else{
                $(this).parents('.floating-group').removeClass('focused');
            }
        }).on("select2:select", function (e) {
            $(this).parents('.floating-group').addClass('focused');
        }).on("select2:unselect", function (e) {
            $(this).parents('.floating-group').addClass('focused');
        });
    });

    $('.defaultTableDesign').DataTable({
        "searching": true,
        "paging": true,
        "info": true,
        "language": {
            "paginate": {
                "next": "<i class='icon-arrow-right-filled'></i>",
                "previous": "<i class='icon-arrow-left-filled'></i>"
            }
        },
        columnDefs: [
            { targets: 'no-sort', orderable: false }
        ]
    });

    $('#acceptDe, #acceptEn').on('input', function () {
        if(this.checked){
            $('.undisable').removeAttr('disabled');
        }else{
            $('.undisable').attr('disabled', true);
        }
    });

    let startLoadingPings = $('.start-loading-ping');
    if(startLoadingPings.length) {
        startLoadingPings.each(function() {
            poll($(this));
        });
    }
    function poll(stack) {
        setTimeout(function () {
            GetData(stack);
        }, 6000);
    }

    function GetData(stack) {
        $.ajax({
            url: "/environment/status/"+stack.data('env'),
            type: "GET",
            dataType: "json",
            success: function(resultData) {
                if(resultData.credentials !== 'none' && resultData.credentials !== 'copied'){
                    stack.parent().children('.open-cred-modal').attr('data-credentials', resultData.credentials);
                    stack.parent().children('.open-cred-modal').show();
                    stack.closest('.container').find('.env-top-nav').find('.open-cred-modal').attr('data-credentials', resultData.credentials);
                    stack.closest('.container').find('.env-top-nav li.hidden').removeClass('hidden');
                }
                if(resultData.status === 'starting' || resultData.status === 'extending'){
                    stack.parent().children('.badge-building').show();
                    const timeText = resultData.status === 'starting' ? resultData.created : resultData.updated;
                    stack.parent().children('.badge-timer').find('.timeSinceCreated').text(timeText);
                    poll(stack);
                }
                if(resultData.status === 'loading'){
                    stack.parent().children('.badge-building').show();
                    stack.parent().children('.badge-timer').find('.timeSinceCreated').text(resultData.created);
                    poll(stack);
                }
                if(resultData.status === 'error' || resultData.status === 'removed' || resultData.extend_error){
                    stack.hide();
                    stack.parent().children('.badge-building').hide();
                    $('.env-creation-error').css('display', 'flex');
                }
                if(resultData.status === 'online' && !resultData.extend_error){
                    let url = window.location.href;
                    if (url.indexOf('?') > -1){
                        url += '&m=congrats'
                    }else {
                        url += '?m=congrats'
                    }
                    window.location.href = url;
                }
            },
            error : function(xhr, textStatus, errorThrown) {
                //...
            },
            timeout: 0,
        });
    }

    $('.user-menu').on('hidden.bs.dropdown', function () {
        $(this).find('i').removeClass('icon-human-active');
        $(this).find('i').addClass('icon-human-inactive');
    });

    $('.user-menu a').on('click', function () {
            $(this).find('i').removeClass('icon-human-inactive');
            $(this).find('i').addClass('icon-human-active');
    });

    $('.env-settings, .micro-nav').on('hidden.bs.dropdown', function () {
        $(this).find('i').removeClass('icon-more-active');
        $(this).find('i').addClass('icon-more-inactive');
    }).find('a').on('click', function () {
        $(this).find('i').removeClass('icon-more-inactive');
        $(this).find('i').addClass('icon-more-active');
    });

    $('.app-settings').on('hidden.bs.dropdown', function () {
        $(this).find('i').removeClass('icon-setting-filled');
        $(this).find('i').addClass('icon-setting-outline');
    }).find('a').on('click', function () {
        $(this).find('i').removeClass('icon-setting-outline');
        $(this).find('i').addClass('icon-setting-filled');
    });

    $('.play-env a, .micro-nav a.play').on('mouseenter', function () {
        $(this).find('i').removeClass('icon-play-inactive');
        $(this).find('i').addClass('icon-play-filled');
    }).on('mouseleave', function (){
        $(this).find('i').removeClass('icon-play-filled');
        $(this).find('i').addClass('icon-play-inactive');
    });

    $('.env-alerts').on('hidden.bs.dropdown', function () {
        $(this).find('i').removeClass('icon-notification-active');
        $(this).find('i').addClass('icon-notification-inactive');
    });

    $('.env-alerts a').on('click', function () {
        $(this).find('i').removeClass('icon-notification-inactive');
        $(this).find('i').addClass('icon-notification-active');
    });
    $('.env-alerts i').trigger('click');

    $('.open-del-modal').on('click', function(e) {
        e.preventDefault();
        $('#remove_env_id').val($(this).data('id'));
        $('#envModalDelete').find('#appName').text($(this).data('name'));
        const name = $(this).data('name');
        $('.copy-code-env').text(name);
        $('#input_confirm_check').on('input', function(e) {
            if ($(this).val() === name) {
                $('#delete-env-btn').removeAttr('disabled');
            } else {
                $('#delete-env-btn').attr('disabled', true);
            }
        });
        $('#envModalDelete').modal({ backdrop: true });
    });

    $('.open-rename-modal').on('click', function (e) {
        e.preventDefault();
        $('#envModalRename').modal({ backdrop: true }).show();
        let headline = $(this).closest('.e1-card-head').find('.headline_env');
        let env_id = $(this).data('id');
        $('#inputRename').val(headline.text());
        $('#inputRename').on('input', function(e){
            if($(this).val().replace(/^\s+|\s+$/g, "").length === 0) {
                $('.renameEnv').attr('disabled', true);
            }else{
                $('.renameEnv').removeAttr('disabled');
            }
        });
        $('.renameEnv').on('click', function (e) {
            $('#preloader').show();
            $.ajax({
                type: "POST",
                url: "/apps/rename/environment",
                data: {
                    _token: $('#csrf-token').attr('content'),
                    env_id: env_id,
                    env_name: $('#inputRename').val()
                },
                success: function(data) {
                    $('#envModalRename').modal('hide');
                    headline.text(data.name);
                    $('#preloader').hide();
                    //location.assign('/home');
                },
                error: function(xhr, status, error){
                    console.error(xhr);
                }
            });
        });

    });

    $('.open-cred-modal').on('click', function (e) {
        $('#envModalCred').modal({ backdrop: true });
        //main.addClass('blur-filter');
        let cred = $(this).data('credentials');
        let env_id = $(this).data('env');
        $('#envModalCred').find('.copy-username').val(cred.user);
        $('#envModalCred').find('.copy-pwd').val(cred.password);
        $('#acceptPwdDelete').change(function(e){
            if(this.checked){
                $('.deleteCred').removeAttr('disabled');
                $('.deleteCred').off('click').on('click', function (e) {
                    $('#preloader').show();
                    $.ajax({
                        type: "POST",
                        url: "/apps/remove/credentials",
                        data: {
                            _token: $('#csrf-token').attr('content'),
                            env_id: env_id
                        },
                        success: function(data) {
                            $('#envModalCred').modal('hide');
                            location.reload();
                        },
                        error: function(xhr, status, error){
                            console.error(xhr);
                        }
                    });
                });
            }else{
                $('.deleteCred').attr('disabled', true);
            }
        });
    });

    $('.showPreloader').on('click', function (e) {
        $('#preloader').show();
    });

    $('.close-alert').on('click', function (e) {
        $(this).closest('.alert-topbar, .alert-topbar-static').fadeOut();
    });

    if(typeof($('.alert-topbar')[0]) != "undefined" && $('.alert-topbar')[0] !== null) {
        setTimeout(function(){
            $(".close-alert").trigger("click");
        }, 6000);
    }

    $('input.money-format').inputmask();
    $('input.phone-format').inputmask("+99 999 999 [9][9][9] [9][9][9]");
    $('input.plz-format').inputmask("9999[9][9][9]");
    $('#inputRename').inputmask({ regex: "^[A-Za-z0-9]+([-_.+!*]+[A-Za-z0-9]+)*$" });
});
